export default "__VITE_ASSET__49d3944b__"